<div class="vault-page-shell">
  <div class="mx-auto max-w-3xl space-y-6">
    <a *ngIf="!orgConnectionId" (click)="cancelAccountConnect()" id="connecting-back" class="vault-back-link cursor-pointer">
      <svg class="h-4 w-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
      </svg>
      Back to account list
    </a>
    <div class="vault-divider" *ngIf="!orgConnectionId"></div>

    <section class="vault-panel px-6 py-8 text-center sm:px-10 sm:py-12">
      <div class="space-y-8">
        <div class="space-y-3">
          <p class="vault-page-kicker">Secure redirect</p>
          <h1 id="connecting-title" class="text-3xl font-semibold tracking-tight text-slate-900 sm:text-4xl">Connecting your account</h1>
          <p id="connecting-subtitle" class="mx-auto max-w-xl text-base leading-7 text-slate-500">Redirecting to sign in so you can authorize this connection in a secure window.</p>
        </div>

        <div class="flex items-center justify-center gap-4">
          <div class="flex h-20 w-20 items-center justify-center rounded-lg border border-slate-200 bg-white p-4 shadow-sm">
            <img imageFallback="unknown-organization" [src]="(configService.systemConfigSubject | async)?.org?.logo_uri" alt="Organization Logo" class="h-full w-full object-contain"/>
          </div>

          <div class="flex items-center gap-2">
            <span class="h-2.5 w-2.5 rounded-full bg-[#5B47FB] opacity-50 animate-pulse"></span>
            <span class="h-2.5 w-2.5 rounded-full bg-[#5B47FB] opacity-70 animate-pulse" style="animation-delay: 200ms;"></span>
            <span class="h-2.5 w-2.5 rounded-full bg-[#5B47FB] animate-pulse" style="animation-delay: 400ms;"></span>
          </div>

          <div class="flex h-20 w-20 items-center justify-center rounded-lg border border-slate-200 bg-white p-4 shadow-sm" id="connecting-system-logo-container">
            <img id="connecting-system-logo"
                 class="h-full w-full object-contain"
                 imageFallback="hospital" src="https://cdn.fastenhealth.com/logos/sources/{{brandId}}.png" />
          </div>
        </div>
      </div>
    </section>

    <section class="vault-panel p-6 sm:p-8">
      <div class="space-y-4">
        <div class="flex items-center gap-2 text-slate-700">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
            <path d="M12 17h.01"/>
          </svg>
          <span class="font-medium">Having trouble?</span>
        </div>
        <p class="text-sm leading-6 text-slate-500">If you’re having trouble connecting to your health system, our support team can help investigate the handoff.</p>
        <button [routerLink]="'/form/support'" [queryParams]="{brand_id: brandId, portal_id: portalId, endpoint_id: endpointId, org_connection_id: orgConnectionId, vault_profile_connection_id: vaultProfileConnectionId, external_id: externalId, external_state: externalState }" class="vault-secondary-button" type="button">
          Contact support
        </button>
      </div>
    </section>
  </div>
</div>
